import React from 'react';

/**
 * The app's one neutral loading state: shown while the account restores, and in
 * place of Now while contextual landing is still choosing the tab
 * (`hooks/useContextualLanding.ts`). One component so the two cannot drift apart.
 */
const AppLoadingState: React.FC = () => (
  <div className="app-loading" role="status" aria-live="polite">
    <div className="loading-spinner" aria-hidden="true" />
    <span className="sr-only">Loading your account</span>
  </div>
);

export default AppLoadingState;
